import EventEmitter from 'events';

/**
 * @param {HTMLSelectElement} el
 */
function getSelectQuantity(el) {
  if (el.value) {
    return parseInt(el.value, 10);
  }

  return 0;
}


class ZonePricetype extends EventEmitter {
  /**
   * @param {HTMLElement} $el
   */
  constructor($el) {
    super();

    this.id = parseInt($el.getAttribute('data-tn-price-type-id'), 10);
    this.price = parseFloat($el.getAttribute('data-tn-price-amount')) || 0;
    this.description = $el.getAttribute('data-tn-pricetype-description') || '';

    /** @type {HTMLSelectElement} */
    this.$select = $el.querySelector('.tn-ticket-selector__pricetype-select');

    this.hasQuantitySelect = !!this.$select;

    if (this.hasQuantitySelect) {
      this.$select.addEventListener('change', this.onQuantityChange);
    }
  }

  onQuantityChange = () => {
    this.emit('quantity-change');
  }

  getQuantity() {
    return getSelectQuantity(this.$select);
  }

  getIsSelectionValid() {
    return true;
  }

  /** @returns {import('./TicketSelector').PriceTypeQuantity} */
  getData() {
    return {
      pricetypeId: this.id,
      price: this.price,
      isUserPrice: false,
      quantity: this.getQuantity(),
      description: this.description,
    };
  }

  setSelectedQuantity(quantity) {
    this.$select.value = quantity;
  }

  limitQuantityOptions(totalRemaining, maxQuantity) {
    const { $select } = this;
    const quantity = this.getQuantity();

    const maxOption = quantity + totalRemaining;

    const $optionsToRemove = [];

    for (let i = 0; i <= maxQuantity; i += 1) {
      const $option = $select.options[i];

      if ($option) {
        if (i > maxOption) {
          $optionsToRemove.push($option);
        }
      } else {
        if (i <= maxOption) {
          const $newOption = document.createElement('option');
          $newOption.text = i;
          $newOption.value = i;
          $newOption.selected = quantity === i;

          $select.appendChild($newOption);
        }
      }
    }

    $optionsToRemove.forEach($el => $select.removeChild($el));
  }

  destroy() {
    this.removeAllListeners();

    if (this.hasQuantitySelect) {
      this.$select.removeEventListener('change', this.onQuantityChange);
    }
  }
}


export default ZonePricetype;
